import swal from 'sweetalert2';

import '../../node_modules/sweetalert2/dist/sweetalert2.css';

export async function prompt(title, text, callback) {
    return swal({
        title,
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#FF5C55',
        cancelButtonColor: '#8a8e92',
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отменить'
    }).then(() => {
        callback();
    });
}

export async function close() {
    return swal.close();
}

export async function success(title, text = null, callback = null) {
    return swal({
        title,
        text,
        type: 'success',
        confirmButtonColor: '#FF5C55',
        confirmButtonText: 'ОК',
    }).then(() => {
        callback && callback();
    });
}

export async function alert(title, text = null) {
    return swal({
        title,
        text,
        type: 'info',
        confirmButtonColor: '#FF5C55',
        confirmButtonText: 'ОК',
    });
}

export async function confirm(title, callback) {
    return swal({
        title,
        text: '',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Отменить',
        confirmButtonColor: '#FF5C55',
        confirmButtonText: 'ОК',
    }).then(callback);
}

export async function error(html, title = 'Ошибка') {
    return swal({
        title,
        html,
        type: 'error'
    });
}


// WEBPACK FOOTER //
// ./src/helpers/alerts.js